import { commonLang, getCurrentSystem, SYSTEM_TYPE } from '@umu/ukit-lang';
import { addQueryString } from '@umu/umu-dom';
import { formatNumToMoney } from './money';

export const getCourseUrl = (url: string) => {
    // 说明订单来源
    return addQueryString(url, { order_origin: 'market' });
};

export const getPrice = (price?: string) => {
    if (!price || parseFloat(price) === 0) {
        return commonLang('免费');
    }
    if (Number(price) < 0) {
        return '';
    }
    return price;
};

export const formatPrice = (price?: string | number, decimal?: number) => {
    if (!price || parseFloat(String(price)) === 0) {
        return commonLang('免费');
    }

    const num = Number(price);

    if (isNaN(num) || num < 0) {
        return '';
    }

    return formatNumToMoney(num, decimal);
};

export const getCurrentPrice = (price?: string | number, decimal?: number) => {
    const system = getCurrentSystem();
    // 日本站点货币金额不存在小数掉
    return formatPrice(price, system === 'JP' ? 0 : decimal);
};

export const getCurrencySymbolBySystem = (sys: SYSTEM_TYPE) => {
    switch (sys) {
        case SYSTEM_TYPE.CN:
            return '￥';
        case SYSTEM_TYPE.JP:
            return 'JPY￥';
        case SYSTEM_TYPE.TW:
            return 'NT$';
        case SYSTEM_TYPE.EN:
        case SYSTEM_TYPE.EM:
            return '$';
    }
    return '';
};

export const getCurrentCurrencySymbol = () => {
    return getCurrencySymbolBySystem(getCurrentSystem() as SYSTEM_TYPE);
};
